export enum Role {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
}

export interface IUser {
  _id: string;
  username: string;
  role: Role;
  token?: string;
  auths: string[];
}

export interface IUserEdit {
  id: string;
  password: string;
  auths: string[];
}
